module.exports = __webpack_public_path__ + "img/White_Logo.eb31e37d.png";